<template>
  <div id="rawMaintain" class="page-container">
    <!-- 操作按钮区 -->
    <div class="btn-box">
      <el-button type="primary" @click="loadCurrentData" icon="el-icon-refresh">读取</el-button>
      <el-button type="success" @click="saveData" icon="el-icon-save">保存</el-button>
    </div>

    <!-- 加载状态/空数据提示 -->
    <div v-if="rawQuantity === 0" class="empty-tip">
      <el-empty description="暂无料仓配置，请等待数据加载..." :image-size="120"></el-empty>
    </div>

    <!-- 料仓列表区 -->
    <div v-else class="silos-box">
      <div class="silo-item" v-for="item in fullSiloList" :key="item.sort">
        <div class="silo-title">料仓 {{ item.sort }}</div>

        <!-- 设定原料量 -->
        <div class="row">
          <span class="label">设定原料量：</span>
          <div class="input-wrap">
            <el-input-number
              v-model.number="item.setRawQuantity"
              :min="0"
              size="small"
              style="width: 100%;"
            />
          </div>
        </div>

        <!-- 当前原料量 -->
        <div class="row">
          <span class="label">当前原料量：</span>
          <div class="text-view">{{ item.currentQuantity || 0 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rawMaintain",
  props: {
    initValue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rawQuantity: 0,
      rawMaintainIno: [],
      equipmentTypes: [
        { equipmentTypeId: 15, quantity: 5 },
        { equipmentTypeId: 22, quantity: 4 }
      ]
    };
  },
  computed: {
    fullSiloList() {
      const list = [];
      for (let sort = 1; sort <= this.rawQuantity; sort++) {
        const target = this.rawMaintainIno.find(item => item.sort === sort);
        list.push(target || {
          id: 0, // 增加id字段，用于修改
          equipmentId: this.initValue.id,
          sort: sort,
          rawId: 0,
          rawName: "",
          setCupQuantity: 0,
          currentCupQuantity: 0,
          setRawQuantity: 0,
          currentQuantity: 0
        });
      }
      return list;
    }
  },
  mounted() {
    this.matchEquipmentType();
    this.loadData();
  },
  methods: {
    matchEquipmentType() {
      const typeId = this.initValue.equipmentTypeID;
      if (!typeId) {
        this.rawQuantity = 0;
        return;
      }
      const matchItem = this.equipmentTypes.find(item => item.equipmentTypeId === typeId);

      this.rawQuantity = matchItem ? matchItem.quantity : 0;
    },
    // 加载数据（会带回id）
    loadData() {
      this.$httpservice.get("api/Equipment/GetRawMaintainAndroid", {
        equipmentId: this.initValue.id
      }).then(res => {
        this.rawMaintainIno = res.body.data || [];
      })
    },
    // 读取设备实时数据
    loadCurrentData() {
      console.log("通知设备上传最新数据");
      this.$httpservice.get(`api/external/yh/raw/publish/${this.initValue.dtuNumber}/1/1?insType=1`);
    },
    saveData() {
      const submitData = {
        rawMaintains: this.fullSiloList,
        dtuNo: this.initValue.dtuNumber
      };

      const hasId = this.fullSiloList.some(item => item.id && item.id > 0);

      if (hasId) {
        this.$httpservice.put("api/Equipment/UpdateRawMaintainAndroid", submitData).then(res => {
          this.$message.success("修改成功");
          this.loadData(); // 保存后刷新数据
        });
      } else {
        this.$httpservice.post("api/Equipment/AddRawMaintain", submitData).then(res => {
          this.$message.success("新增成功");
          this.loadData(); // 保存后刷新数据
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.page-container {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.btn-box {
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
}

.empty-tip {
  padding: 40px 0;
  text-align: center;
}

.silos-box {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.silo-item {
  width: 280px;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.silo-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.label {
  font-size: 14px;
  color: #606266;
  min-width: 80px;
}

.input-wrap {
  flex: 1;
  max-width: 140px;
}

.text-view {
  padding: 4px 8px;
  background: #f8f9fa;
  border-radius: 4px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/RawMaintain.vue